import React, { useState, useContext } from "react";
import { withRouter } from "react-router-dom";


import NewProposalPageView from "./new-proposal-page-view"

export default withRouter(function (props) {
  let {
    user,
  } = props;


  return (
    <div>
      <NewProposalPageView
        loading={!true}
        user={user}
      />

    </div>
  );
});
